@if (channels.length > 0) {
  <div class="schoolChannelListHeaderCont">
    <ion-list-header class="schoolChannelListHeader">{{ headerText }}</ion-list-header>
  </div>
}

@if (!listDisabled && channels.length > 0) {
  <ion-item class="selectAllCheckbox" lines="none">
    <ion-checkbox (click)="onSelectAll()" [(ngModel)]="allSelected" name="selectAll"></ion-checkbox>
    <ion-label>Select all</ion-label>
  </ion-item>
}

@for (channel of channels; track channel) {
  <ion-item class="{{ listDisabled ? 'channelCheckboxSubscribed' : 'channelCheckbox' }}">
    <ion-checkbox
      [(ngModel)]="channel.checked"
      [disabled]="listDisabled"
      [name]="channel.name"
    (ionChange)="selectionChanged()"></ion-checkbox>
    <ion-label class="channelName">{{ channel.name }}</ion-label>
  </ion-item>
}
